var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReitingColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67945 13.0091C10.4293 12.5753 11.0838 11.9949 11.6038 11.3072C11.4445 11.0642 11.3227 10.7796 11.2512 10.4534L11.2265 10.3403C11.0814 9.67765 10.5499 9.1686 9.88157 9.05234C7.20757 8.58713 7.2075 4.74846 9.88157 4.28324C10.5281 4.17077 11.0466 3.69072 11.2111 3.05968C10.0313 1.77272 8.33629 0.96582 6.4528 0.96582C2.88875 0.96582 -0.000488281 3.85506 -0.000488281 7.41911C-0.000488281 9.80775 1.29727 11.8933 3.22616 13.0091V14.5177C3.22616 15.2306 3.80401 15.8084 4.51682 15.8084H8.38879C9.10161 15.8084 9.67945 15.2306 9.67945 14.5177V13.0091ZM3.22616 18.067C3.22616 17.5325 3.65955 17.0991 4.19415 17.0991H8.71146C9.24606 17.0991 9.67945 17.5325 9.67945 18.067C9.67945 18.6016 9.24606 19.035 8.71146 19.035H4.19415C3.65955 19.035 3.22616 18.6016 3.22616 18.067ZM12.622 3.18223C12.8583 2.10281 14.3952 2.09609 14.641 3.1734L14.6526 3.22433C14.6603 3.25905 14.6677 3.29112 14.6756 3.32455C14.9586 4.53014 15.9342 5.45134 17.1556 5.66382C18.2814 5.85969 18.2814 7.47589 17.1556 7.67176C15.9278 7.88538 14.9482 8.81527 14.6711 10.0304L14.641 10.1622C14.3952 11.2395 12.8583 11.2328 12.622 10.1533L12.5973 10.0402C12.3303 8.82071 11.352 7.88387 10.1221 7.6699C8.99834 7.47439 8.99833 5.86119 10.1221 5.66569C11.3478 5.45246 12.3235 4.52139 12.5944 3.30808L12.6127 3.22485L12.622 3.18223Z",
    fill: "url(#paint0_linear_744_1985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_744_1985",
    x1: -0.000488281,
    y1: 19.035,
    x2: 4.48741,
    y2: -1.92715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD90EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25BDD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReitingColor);
export default __webpack_public_path__ + "static/media/reitingColor.e11d0b5d533855f1c515cab2e8bddd28.svg";
export { ForwardRef as ReactComponent };